/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { useSnackbar } from 'notistack';
import {
  Box,
  Button,
  Card,
  CardContent,
  FormControlLabel,
  Grid,
  Switch,
  TextField,
} from '@material-ui/core';
import { Redirect } from 'react-router-dom';
import projectRoleRequest from '../../../requests/api/project_role';

import useStyles from './styles';

function ProjectRoleEditForm({ className, projectRole, ...rest }) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [submitSuccess, setSubmitSuccess] = useState(false);

  if (submitSuccess) {
    return <Redirect to="/administracion/proyecto-roles" />;
  }
  return (
    <Formik
      initialValues={{
        name: `${projectRole.name}` || '',
        minimumLevel: `${projectRole.minimumLevel}` || '',
        active: projectRole.active !== undefined ? projectRole.active : true,
      }}
      validationSchema={Yup.object().shape({
        name: Yup.string().required('Debes ingresar eñ nombre del rol'),
        minimumLevel: Yup.number().required(
          'Debes un nivel mínimo para el rol',
        ),
      })}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
        try {
          // Make API request
          const data = {
            id: projectRole.id,
            name: values.name || null,
            minimumLevel: values.minimumLevel || null,
            active: values.active,
          };

          const response = await projectRoleRequest.putProjectRoleById(data);

          const res = response.data;
          if (res.success) {
            setSubmitSuccess(true);
            setStatus({ success: true });
            setSubmitting(false);
            enqueueSnackbar('Cambios guardados', {
              variant: 'success',
            });
          } else {
            setStatus({ success: false });
            setErrors({ submit: res.data.errorMessage });
            enqueueSnackbar(res.data.errorMessage, {
              variant: 'warning',
              action: (
                <Button href="/administracion/talento">Volver a talento</Button>
              ),
            });
          }
        } catch (error) {
          setStatus({ success: false });
          setErrors({ submit: error.message });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        touched,
        values,
      }) => (
        <form
          className={clsx(classes.emptyRoot, className)}
          onSubmit={handleSubmit}
          {...rest}
        >
          <Card>
            <CardContent>
              <Grid container spacing={3}>
                <Grid item md={6} xs={12}>
                  <TextField
                    error={Boolean(touched.name && errors.name)}
                    fullWidth
                    helperText={touched.name && errors.name}
                    label="Nombre"
                    name="name"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.name}
                    variant="outlined"
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <TextField
                    error={Boolean(touched.minimumLevel && errors.minimumLevel)}
                    fullWidth
                    helperText={touched.minimumLevel && errors.minimumLevel}
                    label="Nivel mínimo"
                    name="minimumLevel"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.minimumLevel}
                    variant="outlined"
                    type="number"
                    InputProps={{
                      inputProps: { min: 0 },
                    }}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <FormControlLabel
                    control={(
                      <Switch
                        checked={values.active}
                        onChange={(e) => setFieldValue('active', e.target.checked)}
                        color="primary"
                      />
                    )}
                    label="Rol activo"
                  />
                </Grid>
              </Grid>
              <Box mt={2}>
                <Button
                  variant="contained"
                  color="secondary"
                  type="submit"
                  disabled={isSubmitting}
                >
                  Guardar
                </Button>
              </Box>
            </CardContent>
          </Card>
        </form>
      )}
    </Formik>
  );
}

ProjectRoleEditForm.propTypes = {
  className: PropTypes.string,
  projectRole: PropTypes.object.isRequired,
};

export default ProjectRoleEditForm;
